/** 论文台套餐：卖额度代付，不向用户卖 API Key */
export type ThesisPlanId = 'trial' | 'outline' | 'draft' | 'sprint'

export type ThesisPlan = {
  id: ThesisPlanId
  name: string
  priceLabel: string
  /** 人民币标价；试用为 0 */
  priceCny: number
  /**
   * 有效天数；0 = Token 不过期（用完再续）
   * 仅试用保留短有效期
   */
  days: number
  /** 生成额度（约等于可消耗 token 万） */
  quotaWan: number
  blurb: string
  highlights: readonly string[]
  recommended?: boolean
}

export const THESIS_PLANS: readonly ThesisPlan[] = [
  {
    id: 'trial',
    name: '新用户赠送',
    priceLabel: '注册赠送',
    priceCny: 0,
    days: 7,
    quotaWan: 20,
    blurb: '注册即送，先把题目与六章目录跑通',
    highlights: ['约 20 万 Token', '开题与目录', '7 天有效'],
  },
  {
    id: 'outline',
    name: '开题包',
    priceLabel: '¥99',
    priceCny: 99,
    days: 0,
    quotaWan: 200,
    blurb: '收窄问题、搭目录、试写关键章',
    highlights: ['约 200 万 Token', '开题 + 目录 + 试写'],
  },
  {
    id: 'draft',
    name: '成稿包',
    priceLabel: '¥199',
    priceCny: 199,
    days: 0,
    quotaWan: 600,
    blurb: '六章正文与编审一轮下来',
    highlights: ['约 600 万 Token', '分章正文 + 编审'],
    recommended: true,
  },
  {
    id: 'sprint',
    name: '冲刺包',
    priceLabel: '¥299',
    priceCny: 299,
    days: 0,
    quotaWan: 1200,
    blurb: '改稿密集、额度更宽裕',
    highlights: ['约 1200 万 Token', '高改稿量'],
  },
] as const

export function getThesisPlan(id: ThesisPlanId): ThesisPlan {
  const plan = THESIS_PLANS.find((p) => p.id === id)
  if (!plan) throw new Error(`unknown plan: ${id}`)
  return plan
}

/** days<=0 → 不过期 */
export function planExpiresAtIso(days: number, from = new Date()): string | null {
  if (!Number.isFinite(days) || days <= 0) return null
  return new Date(from.getTime() + days * 86400_000).toISOString()
}
